import React from 'react';
import useTypedSelector from '../hooks/use-type-selectors';
import { Units } from '../models/Settings';
import {
	centimetersToFeetRounded,
	centimetersToMetersRounded,
	feetToCentimeters,
	metersToCentimeters,
} from '../utils/general';
import '../App.css';

interface MeasureInputProps {
	label: string;
	ariaLabel: string;
	value: number; // in centimeters
	min?: number; // in centimeters
	max?: number; // in centimeters
	onChangeFunc(e: number): void;
}

const MeasureInput: React.FC<MeasureInputProps> = (props: MeasureInputProps) => {
	const settings = useTypedSelector((state) => state.settings);

	function updateValue(e: React.FormEvent<HTMLInputElement>) {
		var value = Number(e.currentTarget.value);

		if (settings.units === Units.Metric) value = metersToCentimeters(value);
		else value = feetToCentimeters(value);

		if (props.min !== undefined) {
			value = Math.max(value, props.min);
		}

		if (props.max !== undefined) {
			value = Math.min(value, props.max);
		}

		props.onChangeFunc(value);
	}

	return (
		<div style={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: '20px' }}>
			<div className='subtitle' style={{ width: '33%' }}>
				{props.label}
			</div>
			<div className='elementValue' style={{ width: '67%' }}>
				<input
					type='number'
					step='0.01'
					onChange={updateValue}
					className='inputBox'
					aria-label={
						props.ariaLabel + (settings.units === Units.Metric ? ' meters' : ' feet')
					}
					value={
						settings.units === Units.Metric
							? centimetersToMetersRounded(props.value)
							: centimetersToFeetRounded(props.value)
					}
					min={
						props.min === undefined
							? 0
							: settings.units === Units.Metric
							? centimetersToMetersRounded(props.min)
							: centimetersToFeetRounded(props.min)
					}
					max={
						props.max === undefined
							? undefined
							: settings.units === Units.Metric
							? centimetersToMetersRounded(props.max)
							: centimetersToFeetRounded(props.max)
					}
				/>
				{settings.units === Units.Metric ? (
					<label className='subtitle'>m</label>
				) : (
					<label className='subtitle'>ft</label>
				)}
			</div>
		</div>
	);
};

export default MeasureInput;
